interface HTMLDialogElement {
  show(): void;
  showModal(): void;
  close(returnValue?: string): void;
}

document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('download-dialog') as HTMLDialogElement | null;
  const modalClose = document.getElementById('download-dialog-close');
  const modalContent = document.getElementById('download-dialog-content');
  const modalCancel = document.getElementById('download-dialog-cancel-button');
  const modalDownload = document.getElementById('download-dialog-download-button') as HTMLAnchorElement;

  document.querySelectorAll('.download-modal-activator').forEach((el) => {

    el.addEventListener('click', () => {
      if (!modal || !modalContent) return;

      const downloadTitle = el.getAttribute('data-download-title');
      const downloadUrl = el.getAttribute('data-download-url');
      const isDirectDownload = el.hasAttribute('data-direct-download');

      modalContent.innerHTML = downloadTitle;
      modalDownload.href = downloadUrl;

      // TODO String ins template überführen und localisierbar machen
      if (isDirectDownload) {
        const fileExtension = el.getAttribute('data-file-extension') ?? '';
        const filename = downloadTitle && fileExtension ? `${downloadTitle}.${fileExtension}` : (downloadTitle ?? '');
        modalDownload.setAttribute('download', filename);
        modalDownload.removeAttribute('target');
        modalDownload.textContent = 'Herunterladen';
      } else {
        modalDownload.removeAttribute('download');
        modalDownload.target = '_blank';
        modalDownload.textContent = 'Vorschau öffnen';
      }

      modal.showModal();
    });
  });

  modalClose?.addEventListener('click', () => {
    modal?.close();
  });
  modalCancel?.addEventListener('click', () => {
    modal?.close();
  });

});





